module.exports = __webpack_public_path__ + "img/rosepetal-dep-delafruit.e9b54d3f.jpg";